import { Path } from 'd3';

export const arcCommand = (
  p: Path,
  radius: number,
  startAngle: number,
  endAngle: number
) =>
  p.arc(0, 0, radius, (startAngle * Math.PI) / 180, (endAngle * Math.PI) / 180);
